module.exports = __webpack_public_path__ + "static/media/DesmosCover.f5de2f52.jpg";